// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editcatelogue_containers {
  overflow: hidden;
  height: 100vh;
}
.editcatelogue_containers .editcatelogue_container {
  width: 100%;
  display: flex;
  overflow: hidden;
}
.editcatelogue_containers .third_para {
  margin: 1rem;
}
.editcatelogue_containers .editcateloguemain {
  width: 100%;
  background: #ffffff;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100vh;
}
.editcatelogue_containers .tvsparts_text {
  font-family: "Nunito";
  font-size: 0.75rem;
  font-weight: 500;
  display: flex;
  padding: 0rem 1rem;
  align-items: center;
}
.editcatelogue_containers .select-lable-img {
  position: relative;
  top: 0.2ex;
  z-index: 1;
  left: 0.5em;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
  text-decoration: underline;
  cursor: pointer;
}
.editcatelogue_containers .editcatelogue_second_para img {
  height: 108px;
  width: 108px;
  border-radius: 6px;
}
.editcatelogue_containers .editcateloguebuttons_container {
  display: flex;
  justify-content: space-between;
  width: 96%;
  margin: 1rem;
}
.editcatelogue_containers .partcateloguebutton {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}
.editcatelogue_containers .part_catelogue_buttons {
  background: #e4ecf7;
  border-radius: 5px;
  font-family: Nunito;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.4rem 1rem;
}
.editcatelogue_containers .edit_catelogue_addbuttons {
  border-radius: 5px;
  font-family: Nunito;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.4rem 1rem;
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  color: #ffffff;
}
.editcatelogue_containers .tabledata {
  display: flex;
  width: 96%;
  margin: 1rem;
}
.editcatelogue_containers .table {
  border-collapse: collapse;
  width: 100%;
  background: #ffffff;
  border: 0.5px solid #999797;
}
.editcatelogue_containers .tablesth {
  color: white;
  text-align: left;
  padding: 14px 12px;
  background-color: #f5f5f5;
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  background: #0c3688;
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px -2px 0px 0px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  color: #ffffff;
}
.editcatelogue_containers .tabletd {
  text-align: left;
  padding: 22px 5px;
  font-style: normal;
  font-weight: 400;
  font-size: 16.4px;
  text-align: left;
  padding: 14px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #070707;
  border-top: 0.5px solid #999797;
}
.editcatelogue_containers .tabletd_view {
  text-align: left;
  padding: 22px 5px;
  text-align: left;
  padding: 14px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  text-decoration-line: underline;
  color: #0c3688;
  border-top: 0.5px solid #999797;
  cursor: pointer;
}
.editcatelogue_containers .footer_div {
  margin-top: 1rem;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}
.editcatelogue_containers .header_border {
  background: #c0c8da;
  height: 2.4rem;
  border: 1px solid #c0c8da;
}
.editcatelogue_containers .header_border > img {
  margin: 0.9rem 1rem;
}
.editcatelogue_containers .edit_catelogue_addbuttons:disabled,
.editcatelogue_containers .edit_catelogue_addbuttons:disabled:hover {
  border-radius: 5px;
  font-family: Nunito;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.4rem 1rem;
  background: #c0cdee !important;
  color: #ffffff;
}
.editcatelogue_containers .header_border > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 1rem;
  display: flex;
  align-items: center;
  letter-spacing: -0.28px;
  margin: 0.7rem 1rem;
}
.editcatelogue_containers .Addnew_text {
  font-family: "Nunito";
  font-size: 20px;
  font-weight: 600;
}
.editcatelogue_containers .editcatelogue_second_para {
  margin: 1rem;
  display: flex;
  flex-direction: column;
}
.editcatelogue_containers .editcatelogue_second_para > img {
  width: 100px;
  height: 100px;
}
.editcatelogue_containers .editcatelogue_second_para > span {
  font-family: Nunito;
  font-size: 14px;
  font-weight: 700;
  text-decoration: underline;
  color: #0c3688;
  margin: 0rem 1.6rem;
}

@media screen and (min-width: 300px) and (max-width: 768px) {
  .editcatelogue_container {
    flex-direction: column;
  }
  .editcateloguemain {
    width: 100% !important;
  }
  .editcateloguemain {
    height: 47vh !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/AddCatelogue/editcatelogue.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AACJ;AAEE;EACE,YAAA;AAAJ;AAGE;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AADJ;AAIE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AAFJ;AAIE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;AAFJ;AAIA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AAFF;AAIE;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,YAAA;AAFJ;AAME;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAJJ;AAOE;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AALJ;AAQE;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mEAAA;EACA,cAAA;AANJ;AASE;EACE,aAAA;EACA,UAAA;EACA,YAAA;AAPJ;AAUE;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;AARJ;AAWE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,8CAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AATJ;AAYE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,+BAAA;AAVJ;AAaE;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,+BAAA;EACA,eAAA;AAXJ;AAcE;EACE,gBAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;AAZJ;AAeE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAbJ;AAgBE;EACE,mBAAA;AAdJ;AAgBE;;EAEE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,8BAAA;EACA,cAAA;AAdJ;AAiBE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAfJ;AAkBE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;AAhBJ;AAmBE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAjBJ;AAoBE;EACE,YAAA;EACA,aAAA;AAlBJ;AAqBE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,cAAA;EACA,mBAAA;AAnBJ;;AAwBC;EACC;IACE,sBAAA;EArBF;EAuBA;IACE,sBAAA;EArBF;EAwBA;IACE,uBAAA;EAtBF;AACF","sourcesContent":[".editcatelogue_containers {\n  overflow: hidden;\n  height: 100vh;\n\n  .editcatelogue_container {\n    width: 100%;\n    display: flex;\n    overflow: hidden;\n  }\n\n  .third_para {\n    margin: 1rem;\n  }\n\n  .editcateloguemain {\n    width: 100%;\n    background: #ffffff;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    height: 100vh;\n  }\n\n  .tvsparts_text {\n    font-family: \"Nunito\";\n    font-size: 0.75rem;\n    font-weight: 500;\n    display: flex;\n    padding: 0rem 1rem;\n    align-items: center;\n  }\n  .select-lable-img{\n    position: relative;\n    top: 0.2ex;\n    z-index: 1;\n    left: 0.5em;\n    background-color: white;\n    padding: 0 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #0c3688;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n.editcatelogue_second_para img{\n  height: 108px;\n  width: 108px;\n  border-radius: 6px;\n}\n  .editcateloguebuttons_container {\n    display: flex;\n    justify-content: space-between;\n    width: 96%;\n    margin: 1rem;\n  }\n\n\n  .partcateloguebutton {\n    display: flex;\n    justify-content: space-between;\n    gap: 1rem;\n  }\n\n  .part_catelogue_buttons {\n    background: #e4ecf7;\n    border-radius: 5px;\n    font-family: Nunito;\n    font-size: 1rem;\n    font-weight: 600;\n    padding: 0.4rem 1rem;\n  }\n\n  .edit_catelogue_addbuttons {\n    border-radius: 5px;\n    font-family: Nunito;\n    font-size: 1rem;\n    font-weight: 600;\n    padding: 0.4rem 1rem;\n    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n    color: #ffffff;\n  }\n\n  .tabledata {\n    display: flex;\n    width: 96%;\n    margin: 1rem;\n  }\n\n  .table {\n    border-collapse: collapse;\n    width: 100%;\n    background: #ffffff;\n    border: 0.5px solid #999797;\n  }\n\n  .tablesth {\n    color: white;\n    text-align: left;\n    padding: 14px 12px;\n    background-color: #f5f5f5;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 1rem;\n    background: #0c3688;\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px -2px 0px 0px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 1rem;\n    color: #ffffff;\n  }\n\n  .tabletd {\n    text-align: left;\n    padding: 22px 5px;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16.4px;\n    text-align: left;\n    padding: 14px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #070707;\n    border-top: 0.5px solid #999797;\n  }\n\n  .tabletd_view {\n    text-align: left;\n    padding: 22px 5px;\n    text-align: left;\n    padding: 14px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 14px;\n    text-decoration-line: underline;\n    color: #0c3688;\n    border-top: 0.5px solid #999797;\n    cursor: pointer;\n  }\n\n  .footer_div {\n    margin-top: 1rem;\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n  }\n\n  .header_border {\n    background: #c0c8da;\n    height: 2.4rem;\n    border: 1px solid #c0c8da;\n  }\n\n  .header_border>img {\n    margin: 0.9rem 1rem;\n  }\n  .edit_catelogue_addbuttons:disabled,\n  .edit_catelogue_addbuttons:disabled:hover {\n    border-radius: 5px;\n    font-family: Nunito;\n    font-size: 1rem;\n    font-weight: 600;\n    padding: 0.4rem 1rem;\n    background: #c0cdee !important;\n    color: #ffffff;\n  }\n\n  .header_border>span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 1rem;\n    display: flex;\n    align-items: center;\n    letter-spacing: -0.28px;\n    margin: 0.7rem 1rem;\n  }\n\n  .Addnew_text {\n    font-family: \"Nunito\";\n    font-size: 20px;\n    font-weight: 600;\n  }\n\n  .editcatelogue_second_para {\n    margin: 1rem;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .editcatelogue_second_para>img {\n    width: 100px;\n    height: 100px;\n  }\n\n  .editcatelogue_second_para>span {\n    font-family: Nunito;\n    font-size: 14px;\n    font-weight: 700;\n    text-decoration: underline;\n    color: #0c3688;\n    margin: 0rem 1.6rem;\n\n  }\n\n}\n @media screen and (min-width:300px) and (max-width:768px) {\n  .editcatelogue_container{\n    flex-direction: column;\n  }\n  .editcateloguemain{\n    width: 100% !important;\n  }\n\n  .editcateloguemain {\n    height: 47vh !important;\n  }\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
